module.exports = __webpack_public_path__ + "img/Weapon_118.5e763612.png";